import { useSelector } from 'react-redux';
import { parseAddressPhone } from '@/utils/phone';
const useReduxUtils = () => {
  const accountData = useSelector(store => store.account)?.account;
  const orderData = useSelector(store => store.order)?.order;
  const commonData = useSelector(store => store.common);
  const authData = useSelector(store => store.auth)?.auth;
  const getSelectedLocation = () => {
    let location = {};
    if (accountData?.deviceLocation?.data) {
      location = accountData?.deviceLocation?.data;
    }
    if (orderData?.address?.geoData?.coordinates) {
      location = orderData?.address?.geoData?.coordinates;
    }
    return location;
  };
  const parsePhoneNumber = phoneNumber => {
    return parseAddressPhone(phoneNumber, {
      masterCountries: commonData?.masterCountries || [],
      fallbackCountryCode: authData?.countryCode || '',
      fallbackPhoneCode: authData?.phoneCode || ''
    });
  };
  const getMasterCountry = ({
    countryCode,
    phoneCode
  }) => {
    if (phoneCode) {
      const normalized = String(phoneCode).startsWith('+') ? phoneCode : `+${String(phoneCode).replace(/[^\d]/g, '')}`;
      return commonData.masterCountries.find(i => i.phoneCode === phoneCode) || commonData.masterCountries.find(i => i.phoneCode === normalized) || commonData.masterCountries.find(i => String(i.phoneCode).replace(/[^\d]/g, '') === String(phoneCode).replace(/[^\d]/g, ''));
    } else {
      return commonData.masterCountries.find(i => i.isoCode === countryCode);
    }
  };
  const isLocationPermissionDenied = () => {
    return !orderData?.address?.geoData?.coordinates?.lat && !accountData?.deviceLocation?.isLocationAllowed;
  };
  return {
    getSelectedLocation,
    parsePhoneNumber,
    getMasterCountry,
    isLocationPermissionDenied
  };
};
export default useReduxUtils;